import { useMemo } from "react";

// Start Saturday of the week we are on
function startOfRailWeek(date: Date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const day = d.getDay(); // 0=Sun ... 6=Sat
  const backDays = (day === 6) ? 0 : (day + 1); // go back to Saturday
  d.setDate(d.getDate() - backDays);
  d.setHours(0, 0, 0, 0);
  return d;
}

function weekDiffInclusive(start: Date, current: Date) {
  const msPerWeek = 7 * 24 * 60 * 60 * 1000;
  return Math.round((current.getTime() - start.getTime()) / msPerWeek) + 1;
}

/**
 * Hook that returns UK Rail Week + Rail Year (Apr → Mar, Sat → Fri)
 */
export function useUKRailWeek() {
  return useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const calYear = today.getFullYear();
    const apr1ThisYear = new Date(calYear, 3, 1); // Apr 1

    let railYearStart: Date;
    let railYearLabel: string;

    if (today >= apr1ThisYear) {
      railYearStart = apr1ThisYear;
      railYearLabel = `${calYear}`;
    } else {
      railYearStart = new Date(calYear - 1, 3, 1);
      railYearLabel = `${calYear}`;
    }

    // Week 1 starts on the Saturday ON or BEFORE April 1
    const apr1Day = railYearStart.getDay(); // 0=Sun ... 6=Sat
    const backDays = (apr1Day === 6) ? 0 : (apr1Day + 1);

    const week1Start = new Date(railYearStart);
    week1Start.setDate(railYearStart.getDate() - backDays);
    week1Start.setHours(0, 0, 0, 0);

    const thisWeekStart = startOfRailWeek(today);
    const week = weekDiffInclusive(week1Start, thisWeekStart);

    return { currentWeek: week, currentYear: railYearLabel };
  }, []);
}
